module.exports = "//public.getcloudapp.com/packs/media/images/cloudapp-logo-horizontal-9a0e316f7b038832f406937ef996bde1.svg";